import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, selectedCategories, onCategoryChange, onClearFilters }) => {
  const [expandedCategories, setExpandedCategories] = useState(new Set(['all']));

  const toggleCategory = (categoryId) => {
    const newExpanded = new Set(expandedCategories);
    if (newExpanded.has(categoryId)) {
      newExpanded.delete(categoryId);
    } else {
      newExpanded.add(categoryId);
    }
    setExpandedCategories(newExpanded);
  };

  const handleCategorySelect = (categoryId) => {
    const newSelected = new Set(selectedCategories);
    if (newSelected.has(categoryId)) {
      newSelected.delete(categoryId);
    } else {
      newSelected.add(categoryId);
    }
    onCategoryChange(Array.from(newSelected));
  };

  const renderCategory = (category, level = 0) => {
    const isExpanded = expandedCategories.has(category.id);
    const isSelected = selectedCategories.includes(category.id);
    const hasChildren = category.children && category.children.length > 0;

    return (
      <div key={category.id} className="mb-1">
        <div 
          className={`flex items-center justify-between p-2 rounded-md cursor-pointer transition-micro ${
            isSelected ? 'bg-primary-50 text-primary' : 'hover:bg-secondary-50'
          }`}
          style={{ paddingLeft: `${8 + level * 16}px` }}
        >
          <div className="flex items-center space-x-2 flex-1">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => handleCategorySelect(category.id)}
              className="w-4 h-4 text-primary border-border rounded focus:ring-primary focus:ring-2"
            />
            <span className="text-sm font-body-normal text-text-primary">
              {category.name}
            </span>
            <span className="text-xs text-text-muted">
              ({category.productCount})
            </span>
          </div>
          {hasChildren && (
            <button
              onClick={() => toggleCategory(category.id)}
              className="p-1 hover:bg-secondary-100 rounded"
            >
              <Icon 
                name={isExpanded ? 'ChevronDown' : 'ChevronRight'} 
                size={16} 
                className="text-text-muted"
              />
            </button>
          )}
        </div>
        {hasChildren && isExpanded && (
          <div className="ml-2">
            {category.children.map(child => renderCategory(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-body-medium text-text-primary">
          Categorías
        </h3>
        {selectedCategories.length > 0 && (
          <button
            onClick={onClearFilters}
            className="text-xs text-primary hover:text-primary-700 font-body-medium"
          >
            Limpiar
          </button>
        )}
      </div>
      
      <div className="space-y-1 max-h-96 overflow-y-auto">
        {categories.map(category => renderCategory(category))}
      </div>
    </div>
  );
};

export default CategoryFilter;